import { HeroNumberWithFields } from "@aidkitorg/types/lib/survey";
import { ReportFilterConfig } from "@aidkitorg/types/lib/admin-panel/filters";
import { useState, useEffect } from "react";
import { BooleanExprToFilterGroupConverter, FilterGroupToBooleanExprConverter } from "../../shared/utils/filterConverters";

export const useApplicantCountFormState = (component?: HeroNumberWithFields) => {
  const [filterConfig, setFilterConfig] = useState<ReportFilterConfig | undefined>(undefined);

  // Initialize filter config from component if editing
  useEffect(() => {
    if (!component) return;

    if (component.filter) {
      try {
        const convertedFilter = BooleanExprToFilterGroupConverter.convert(component.filter);
        if (convertedFilter) {
          setFilterConfig({ enabled: true, config: convertedFilter });
        }
      } catch (error) {
        console.warn('Failed to convert saved filter config:', error);
      }
    }
  }, [component]);

  const buildApplicantCountObject = (): HeroNumberWithFields => {
    const applicantCount: HeroNumberWithFields = {
      kind: 'Hero Number',
      title: 'Total Applicants',
      summary: {
        kind: 'Count'
      },
      useCommas: true,
    };

    // Add filter if it's configured
    if (filterConfig && filterConfig.enabled && filterConfig.config) {
      const booleanExpr = FilterGroupToBooleanExprConverter.convertFromConfig(filterConfig);
      if (booleanExpr) {
        applicantCount.filter = booleanExpr;
      }
    }

    return applicantCount;
  };

  const isFormStateValid = true;

  return {
    filterConfig,
    setFilterConfig,
    buildApplicantCountObject,
    isFormStateValid
  };
};